// Цифра непрочитанных на иконке приложения (этап 9, Badging API).
//
// Единственная точка вызова `navigator.setAppBadge`/`clearAppBadge` в приложении
// (в service worker — своя, он живёт вне бандла). Источник числа один: backend
// (`unreadTotal`), клиент его не пересчитывает.
//
// Ограничения платформы: на iOS бейдж есть только у PWA с экрана «Домой» и при
// выданном разрешении на уведомления, а обновляется он лишь при приходе push или
// при запуске приложения. В браузере без Badging API все вызовы — no-op.

let lastApplied = null;

export function isAppBadgeSupported() {
  return typeof navigator !== 'undefined' && typeof navigator.setAppBadge === 'function';
}

/**
 * Поставить цифру (или снять её при нуле). Повторный вызов с тем же значением
 * ничего не делает: API дешёвый, но лишние промисы на каждом обновлении списка
 * чатов не нужны.
 */
export function applyAppBadge(count) {
  const value = Number(count);
  const normalized = Number.isFinite(value) && value > 0 ? Math.floor(value) : 0;
  if (!isAppBadgeSupported() || normalized === lastApplied) {
    return false;
  }
  lastApplied = normalized;
  try {
    // Промис отклоняется, если разрешение отозвано, — это не ошибка приложения.
    const result = normalized > 0 ? navigator.setAppBadge(normalized) : navigator.clearAppBadge();
    if (result && typeof result.catch === 'function') {
      result.catch(() => {});
    }
    return true;
  } catch {
    return false;
  }
}

/** Сброс памяти о последнем значении (выход из аккаунта, тесты). */
export function resetAppBadgeCache() {
  lastApplied = null;
}
